// src/components/Clock.js
import React, { useState, useEffect } from "react";

const Clock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="
        flex 
        items-center 
        justify-center 
        bg-gradient-to-r 
        from-[#137a7f] 
        to-blue-500 
        text-white 
        font-bold 
        px-4 
        py-2 
        rounded 
        shadow-md
        "
    >
      {currentTime.toLocaleString()}
    </div>
  );
};

export default Clock;
